import {
    Box,
    Button,
    Typography,
    TextField,
    TextareaAutosize,
} from '@material-ui/core';

import { useStyles } from '@pages/account/wishlists/create/index';
import { useTranslation } from '@tools/i18n';
export default function StandardWishlistConfigurator({ currentSelected, onChange, onContinue, step }) {
    const classes = useStyles();
    const { t } = useTranslation(['account']);


    return (
        <Box className={classes.wrapper}>
            <Typography variant="h6" className={classes.title}>
                {t('wishlist-wizard-standard-title')}
            </Typography>

            <TextField
                fullWidth
                label={t('wishlist-wizard-standard-title-input-label')}
                value={currentSelected.name}
                onChange={e => onChange({ ...currentSelected, name: e.currentTarget.value })}
                variant="outlined"
                margin="normal"
                className={classes.input}
                placeholder={t('wishlist-wizard-standard-title-input-placeholder')}
                InputLabelProps={{ shrink: true }}
            />
            <Typography variant="subtitle1" className={classes.title}>
                {t('wishlist-wizard-standard-description-textarea-label')}
            </Typography>
            <TextareaAutosize
                className={classes.textArea}
                value={currentSelected.text}
                onChange={e => onChange({ ...currentSelected, text: e.currentTarget.value })}
                placeholder={t('wishlist-wizard-standard-description-textarea-placeholder')}
            />

            <Button fullWidth className={classes.continueButton} onClick={onContinue} disabled={!currentSelected.name}>
                {t('wishlist-wizard-create-button')}
            </Button>
        </Box>
    );
};